var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFashion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Clothes-Design-Tape-Measure--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Clothes Design Tape Measure Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.92 10.25a0.25 0.25 0 0 0 -0.19 0.09l-2.5 3a0.25 0.25 0 0 0 0.19 0.41h8.66a0.25 0.25 0 0 0 0.19 -0.09l2.5 -3a0.25 0.25 0 0 0 -0.19 -0.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15h-2a0.25 0.25 0 0 0 -0.25 0.25v3.25a0.75 0.75 0 0 1 -1.5 0v-3.25a0.25 0.25 0 0 0 -0.25 -0.25H15a0.25 0.25 0 0 0 -0.25 0.25v3.25a0.75 0.75 0 0 1 -1.5 0v-3.25A0.25 0.25 0 0 0 13 15H9.5a0.5 0.5 0 0 0 -0.5 0.5v7a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5 -1.5v-6a1.5 1.5 0 0 0 -1.5 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0h-1A1.5 1.5 0 0 0 0 1.5v6A1.5 1.5 0 0 0 1.5 9h1a0.25 0.25 0 0 0 0.25 -0.25V0.25A0.25 0.25 0 0 0 2.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 8.5v-7A1.5 1.5 0 0 0 21.5 0H20a0.25 0.25 0 0 0 -0.25 0.25V3.5a0.75 0.75 0 0 1 -1.5 0V0.25A0.25 0.25 0 0 0 18 0h-3.5a0.25 0.25 0 0 0 -0.25 0.25V3.5a0.75 0.75 0 0 1 -1.5 0V0.25A0.25 0.25 0 0 0 12.5 0H9a0.25 0.25 0 0 0 -0.25 0.25V3.5a0.75 0.75 0 0 1 -1.5 0V0.25A0.25 0.25 0 0 0 7 0H4.5a0.25 0.25 0 0 0 -0.25 0.25v8.5A0.25 0.25 0 0 0 4.5 9h18a0.5 0.5 0 0 0 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFashion);
export default ForwardRef;